export default "__VITE_ASSET__956602d7__"